// SPDX-License-Identifier: LicenseRef-Proprietary

import { useCallback } from 'react';
import { logActivity } from '../../../lib/storage';
import type { TreeState } from '../../../lib/validation';
import type { ViewPrefs } from '../../../store/vaccineClientStore';

/**
 * Hook for decision tree export operations (SVG, PNG, shareable link)
 * Extracted from DecisionTreeBuilder for better separation of concerns
 */
export function useDecisionTreeExport(
  getTreeState: () => TreeState,
  view: ViewPrefs
) {


  const exportPNG = useCallback(() => {
    const svg = document.querySelector('.decision-tree-svg') as SVGElement | null;
    if (!svg) return;
    // size from bbox (+ padding)
    const bb = (svg as SVGSVGElement).getBBox();
    const width = Math.ceil(bb.x + bb.width + 40);
    const height = Math.ceil(bb.y + bb.height + 40);
    const clone = svg.cloneNode(true) as SVGElement;
    clone.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
    clone.setAttribute('width', String(width));
    clone.setAttribute('height', String(height));
    const svgBlob = new Blob([new XMLSerializer().serializeToString(clone)], { type: 'image/svg+xml;charset=utf-8' });
    const url = URL.createObjectURL(svgBlob);
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext('2d')!;
      const bg = getComputedStyle(document.documentElement).getPropertyValue('--bg-deep') || '#0A1428';
      ctx.fillStyle = bg.trim();
      ctx.fillRect(0, 0, width, height);
      ctx.drawImage(img, 0, 0);
      URL.revokeObjectURL(url);
      canvas.toBlob((blob) => {
        if (!blob) return;
        const dl = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = dl;
        a.download = `decision-tree-${new Date().toISOString().split('T')[0]}.png`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(dl);
        logActivity('Exported decision tree as PNG');
      });
    };
    img.src = url;
  }, []);



  return {
    exportPNG
  };
}

